'use client';

import { tsr } from '@/libs/ts-rest/ts-rest';
import { createSavedJobListQueryOptions } from '@/modules/job/contracts';
import type { SavedJobListQueryOptions } from '@/modules/job/contracts';

export const useSavedJobListQuery = (query?: Record<string, unknown>, options?: Partial<SavedJobListQueryOptions>) => {
	const queryOptions = createSavedJobListQueryOptions(query);

	return tsr.jobs.favorite.findMany.useQuery({
		...queryOptions,
		...options,
	});
};
